import React from "react";
import { Link } from "react-router-dom";
import "./StockBack.css";

const RECENT_REWARDS = [
  { merchant: "Apple Store", amount: "$1,199", reward: "$59.95", date: "Mar 18", stock: "AAPL" },
  { merchant: "Amazon", amount: "$234", reward: "$11.70", date: "Mar 15", stock: "AMZN" },
  { merchant: "Tesla Supercharger", amount: "$45", reward: "$2.25", date: "Mar 12", stock: "TSLA" },
  { merchant: "Whole Foods", amount: "$187", reward: "$9.35", date: "Mar 10", stock: "AMZN" },
  { merchant: "Netflix", amount: "$15.49", reward: "$0.77", date: "Mar 8", stock: "NFLX" },
];

const REDEMPTION_OPTIONS = [
  { label: "Keep as stocks", desc: "Let your rewards grow in your portfolio", icon: "📈" },
  { label: "Withdraw to cash", desc: "Transfer to your bank account", icon: "💵" },
  { label: "Reinvest", desc: "Use rewards to buy more stocks", icon: "🔄" },
];

export default function StockBack() {
  return (
    <div className="stockback-page">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="stockback-hero">
        <h1 className="stockback-title">Stock-Back</h1>
        <p className="stockback-subtitle">Earn 5% back in stocks on every purchase with your eToro Visa card.</p>
      </section>

      <div className="stockback-stats-row">
        <div className="stockback-stat highlight">
          <span className="stockback-stat-value">5%</span>
          <span className="stockback-stat-label">Back rate</span>
        </div>
        <div className="stockback-stat">
          <span className="stockback-stat-value">$847</span>
          <span className="stockback-stat-label">Total earned</span>
        </div>
        <div className="stockback-stat">
          <span className="stockback-stat-value">$123</span>
          <span className="stockback-stat-label">This month</span>
        </div>
      </div>

      <section className="stockback-balance">
        <div className="stockback-balance-header">
          <span className="stockback-balance-title">Current Balance</span>
          <span className="stockback-balance-amount">$847.32</span>
        </div>
        <div className="stockback-balance-growth">
          <span className="stockback-growth-label">Portfolio growth</span>
          <span className="stockback-growth-value">+$62.15 (+7.3%)</span>
        </div>
      </section>

      <section className="stockback-recent">
        <h3 className="section-title">Recent Rewards</h3>
        {RECENT_REWARDS.map((r, i) => (
          <div key={i} className="stockback-reward-item">
            <div className="stockback-reward-info">
              <span className="stockback-reward-merchant">{r.merchant}</span>
              <span className="stockback-reward-meta">{r.date} · {r.amount} spent</span>
            </div>
            <div className="stockback-reward-right">
              <span className="stockback-reward-amount">+{r.reward}</span>
              <span className="stockback-reward-stock">{r.stock}</span>
            </div>
          </div>
        ))}
      </section>

      <section className="stockback-redeem">
        <h3 className="section-title">Redemption Options</h3>
        {REDEMPTION_OPTIONS.map((opt, i) => (
          <button key={i} className="stockback-redeem-item" type="button">
            <span className="stockback-redeem-icon icon-lean">{opt.icon}</span>
            <div className="stockback-redeem-info">
              <span className="stockback-redeem-label">{opt.label}</span>
              <span className="stockback-redeem-desc">{opt.desc}</span>
            </div>
            <span className="stockback-redeem-arrow">→</span>
          </button>
        ))}
      </section>

      <div className="stockback-close-wrap">
        <Link to="/benefits" className="stockback-close-btn">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
